import React from 'react';
import clsx from 'clsx';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';

const listItems = (locations, location) => locations.map((item) => ({
  key: `workspace_request_location_${item.id}`,
  text: item.description,
  value: item.value,
  active: item.value === location,
  description: item.regional_display_name,
}));

const WorkspaceHubsDropdown = ({
  disabled,
  onChange,
  className,
  fluid,
  locations,
  readStatus,
  location,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      className={clsx('aridhia-workspace-locations-dropdown', 'max-content', className)}
      clearable
      disabled={disabled}
      direction="left"
      fluid={fluid}
      loading={readStatus === states.PENDING}
      onChange={(e, { value }) => onChange(value)}
      options={listItems(locations, location)}
      placeholder={intl.formatMessage({ id: 'workspace.location.select.placeholder' })}
      selection
      value={location}
    />
  );
};

export default WorkspaceHubsDropdown;
